/*
 * Copyright (c) 2022
 * 
 * Created Date: Friday, September 30th 2022, 3:37:42 pm
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

import IconConfirm from "assets/icons/IconConfirm"
import Swal from "sweetalert2"
import { ButtonDanger, ButtonPrimary, ButtonSecondary } from "components/Common/Buttons"
import { useTranslation } from "react-i18next"

const LunaAlertContent = ({ title, description, icon = <IconConfirm width={20} height={20} />, confirmButtonText = 'OK', cancelButtonText = null, type = "primary", showCancelButton = false, onConfirmButtonClicked = () => { } }) => {
    const { t } = useTranslation()
    const onPreConfirmButtonClicked = () => {
        Swal.close()
        onConfirmButtonClicked()
    }

    return <div className="luna-alert-content-container">
        <div className="luna-alert-content">
            <div className={`luna-alert-icon-container ${type}`}>
                {icon}
            </div>

            <div className="luna-alert-main-content">
                <p className="title">{title}</p>
                <p className="description">{description}</p>
            </div>
        </div>

        <div className="luna-alert-footer">
            {showCancelButton && <ButtonSecondary onClick={Swal.close}>{cancelButtonText || t("common.cancel")}</ButtonSecondary>}
            <ButtonPrimary onClick={onPreConfirmButtonClicked}>{confirmButtonText}</ButtonPrimary>
        </div>
    </div>
}

export default LunaAlertContent
